module.exports = __webpack_public_path__ + "fonts/a025160.ttf";